import Navbar from "./NavBar";
import Footer from "./Footer";


const Wrappers = ({ children }: { children: React.ReactNode }) => {



  return (
    <section className="relative">
      {/* Enhanced Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="relative">
        {children}
      </main>

      {/* Enhanced Footer */}
      <Footer />
    </section>
  )
}

export default Wrappers